import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MarineInsuranceModel } from '@data-layer/models/marine-insurance';
import { enumIsfState } from '@data-layer/enums/isf';
import { enumEntrySummaryState } from '@data-layer/enums/entry-summaries';
import { enumInsuranceState, enumMarineInsuranceEntityType } from '@data-layer/enums/marine-insurance';
import { DocumentModel } from '@data-layer/models/documents';
import { enumDocumentRootEntityType, enumDocumentState } from '@data-layer/enums/documents';
import { enumPaymentState } from '@data-layer/enums/payments';

@Component({
  selector: 'app-marine-insurance-quote-view-card',
  templateUrl: './marine-insurance-quote-view-card.component.html',
  styleUrls: ['./marine-insurance-quote-view-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceQuoteViewCardComponent {
  @Input() public marineInsurance: MarineInsuranceModel;
  @Input() public state: enumIsfState | enumEntrySummaryState;
  @Input() public entity: enumMarineInsuranceEntityType;
  @Input() public isEditable: boolean = true;
  @Input() public documents: DocumentModel;
  @Input() public isPendingAdminApproval: boolean;
  @Input() public isShowUpdated: boolean;

  @Output() public edit: EventEmitter<void> = new EventEmitter<void>();

  public isShowTerms: boolean;

  public showTerms(): void {
    this.isShowTerms = true;
  }

  public hideTerms(): void {
    this.isShowTerms = false;
  }

  public get isShowCertificate(): boolean {
    return (
      !!this.marineInsurance?.certificate?.issueDate &&
      [enumPaymentState.SUCCESS, enumPaymentState.DELAYED].includes(this.marineInsurance?.paymentState)
    );
  }

  public get latestCertificateDocument(): DocumentModel {
    if (Array.isArray(this.documents)) {
      return (this.documents || [])
        .filter(
          (item: DocumentModel) =>
            item.rootEntityType === enumDocumentRootEntityType.MARINE_INSURANCE_SHIPMENT && item.state === enumDocumentState.UPLOADED,
        )
        .sort((a: DocumentModel, b: DocumentModel) => Date.parse(a.createdDate) - Date.parse(b.createdDate))?.[0];
    } else {
      return this.documents as unknown as DocumentModel;
    }
  }

  public get isEditableQuote(): boolean {
    return this.isEditable && this.marineInsurance?.state === enumInsuranceState.QUOTE;
  }

  public get isShowUpdatedInsuredValue(): boolean {
    return (
      this.isShowUpdated &&
      this.marineInsurance?.state !== enumInsuranceState.QUOTE &&
      (!!this.marineInsurance?.updatedInsuredValue?.insuredAmount ||
        !!this.marineInsurance?.updatedInsuredValue?.commodity ||
        !!this.marineInsurance?.updatedInsuredValue?.goodsTypeDescription)
    );
  }

  public get isShowUpdatedDate(): boolean {
    return this.isShowUpdated && this.marineInsurance?.state !== enumInsuranceState.QUOTE && !!this.marineInsurance?.updatedShippingDate;
  }

  public get isAnovaDown(): boolean {
    return this.marineInsurance?.isProviderWasDown;
  }
}
